import React, { useState, useRef, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { UnorderedListOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import logo from "@/assets/logo.png";
import Wlogo from "@/assets/logo.png";
import "./index.less";
import { getCurrentLanguage, setLanguage } from "@/store/data/global";

const NewNav = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const isHomePage = location.pathname === "/";

  // 滚动监听
  useEffect(() => {
    if (!isHomePage) {
      setIsScrolled(true);
      return;
    }

    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  // 导航项配置
  const navItems = useMemo(() => [
    { path: "/", key: "/", name: { EN: "Home", JA: "ホーム" } },
    { path: "/sustainable", key: "sustainable", name: { EN: "Sustainable Development", JA: "持続可能な開発" } },
    { path: "/cases", key: "cases", name: { EN: "Case Studies", JA: "事例紹介" } },
    { path: "/news", key: "news", name: { EN: "News", JA: "ニュース" } },
    { path: "/future", key: "future", name: { EN: "Future", JA: "未来" } },
    { path: "/business", key: "business", name: { EN: "Business", JA: "ビジネス" } },
  ], []);

  const isActiveLink = (navItem) => {
    if (location.pathname === "/") return navItem.key === "/";
    return location.pathname === navItem.path;
  };

  return (
    <div className={`new_nav_page ${isScrolled ? 'scrolled' : ''} ${isHomePage ? 'home-page' : 'other-page'}`}>
      <div className="nav_warp">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img 
              src={isHomePage && !isScrolled ? Wlogo : logo} 
              alt="Logo" 
              className="logo-image" 
            />
          </Link>
        </div>

        {/* 语言切换 */}
        <div className="lang flex">
          {['JA', 'EN'].map((code) => (
            <div className="lang_item" key={code}>
              <span
                className={currentLanguage === code ? "active" : ""}
                onClick={() => dispatch(setLanguage(code))}
              >
                {code === 'JA' ? '日本語' : 'EN'}
              </span>
            </div>
          ))}
        </div>

        {/* 导航菜单 */}
        {!isScrolled ? (
          <div className="nav_list">
            {navItems.map((item) => (
              <div className="nav_item" key={item.key}>
                <Link
                  to={item.path}
                  className={isActiveLink(item) ? "active" : ""}
                >
                  {item.name[currentLanguage]}
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <div 
            className="short_nav_list"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className={`short-cube ${isHovered ? 'hidden' : ''}`}>
              <p>Menu</p>
              <UnorderedListOutlined />
            </div>
            
            <div className={`long_nav ${isHovered ? 'visible' : 'hidden'}`}>
              {navItems.map((item) => (
                <div className="nav_item" key={item.key}>
                  <Link
                    to={item.path}
                    className={isActiveLink(item) ? "active" : ""}
                  >
                    {item.name[currentLanguage]}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewNav;